module.exports = __webpack_public_path__ + "assets/img/18_1850.6d15eff5.jpg";